import { Component, OnInit, Output, EventEmitter, Input, ViewEncapsulation } from '@angular/core';
import { faCloudUpload, faSpinner } from '@fortawesome/pro-light-svg-icons';
import { from } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { AWSUploadService } from '@clooper/core';
import * as uuid from 'uuid';

@Component({
  selector: 'app-upload-box',
  templateUrl: './upload-box.component.html',
  styleUrls: ['./upload-box.component.scss'],
})
export class UploadBoxComponent implements OnInit {

  icons = {
    upload: faCloudUpload,
    spinner: faSpinner
  }
  selectedFiles: FileList
  uploading: boolean;

  id = 'file-' + uuid.v4();
  uploadedFile: any

  // Inputs
  @Input() label: string;
  @Input() disabled: boolean;
  @Input() multiple: boolean;
  @Input() required: boolean;
  @Input() allowExt: string[];
  @Input() inputCaption: string;

  @Input() dir: string = 'uploads';
  @Input() accept: string = 'jpg, jpeg, gif, png';
  @Input() title: string = 'Upload photos';
  @Input() caption: string = 'Click on the box to upload as photos from your computer';
  @Input() viewType = 'upload-box'
  @Output() change = new EventEmitter<FileList>();
  @Output() fileUploadUpdate = new EventEmitter();

  constructor(private service: AWSUploadService) { }

  ngOnInit() {}

  filesSelected() {}

  trigger(el: HTMLInputElement) {
    el.click();
  }

  onFileChange(event: any, inputFile: any) {
    const { files } = event.target;
    const fileList = []
    for (const file of files) {
      file.hash = `filehash-${uuid.v4()}`;
      fileList.push(file);
    }    
    from(fileList).pipe(concatMap((file: any) => {
      const { name: description, hash } = file;
      const data = {status: 'progress', description, hash};
      this.fileUploadUpdate.emit(data);
      this.uploadedFile = data;
      return this.service.upload(file, this.dir)
    })).subscribe(
      res => { 
        if(res && res.status === 'complete') {
          if(inputFile) inputFile.value = '';
          this.fileUploadUpdate.emit(res);
          this.uploadedFile = res;
        }
        return
        if (res && res.message) {
          // this.uploadProgress = res.message;
          if (res.message === 100) {
            if (res.Location) {
              // this.uploadComplete.emit(res.Location)
              // this.uploading = false;
            }
          }
        }
      },
      err => console.error(err)
    )
  }

}
